import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {CountrySelectorService} from '../country-selector.service';
import {first} from 'rxjs/operators';
import {DcpBaseStoreModel} from '../../model/dcp-config-service/basestores-country.model';
import {JsonService} from '@dcp/configurator';
import {BaseStoreService} from '../base-store.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

export const DEFAULT_CURRENCY: string = 'USD';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpCurrencyService {
  private activeCurrency: string = '';
  private activeCurrencySubject: BehaviorSubject<string> = new BehaviorSubject<string>(DEFAULT_CURRENCY);
  private currenciesSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([DEFAULT_CURRENCY]);

  constructor(
    private countrySelectorService: CountrySelectorService,
    private jsonService: JsonService,
    private baseStoreService: BaseStoreService
  ) {
    this.refreshCurrencies();
    this.countrySelectorService
      .getChangeNotification()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.refreshCurrencies();
      });
  }

  public refreshCurrencies(): void {
    this.baseStoreService
      .getCurrentBaseStore()
      .pipe(first(), untilDestroyed(this))
      .subscribe((baseStore: DcpBaseStoreModel) => {
        const defaultCurrency: string = baseStore?.defaultCurrency?.isocode;
        const currencies: string[] = this.jsonService.parseSafely(
          this.jsonService.findDataSet(baseStore?.data, 'currencies').value
        ) as string[];

        if (defaultCurrency && defaultCurrency !== this.activeCurrency) {
          this.activeCurrency = defaultCurrency;
          this.activeCurrencySubject.next(defaultCurrency);
          this.currenciesSubject.next(currencies);
        }
      });
  }

  public getActive(): Observable<string> {
    return this.activeCurrencySubject.asObservable();
  }

  public getCurrencies(): Observable<string[]> {
    return this.currenciesSubject.asObservable();
  }
}
